import 'react-table/react-table.css'

import { VIEW_DATASET_MEASUREMENT, VIEW_DATASET_SUMMARY } from '../../../constants/saxs'

import DataCollectionListMeasurementTableHeader from './DataCollectionListMeasurementTableHeader'
import DataCollectionListMeasurementTableRow from './DataCollectionListMeasurementTableRow'
import DataCollectionListSummaryTableHeader from './DataCollectionListSummaryTableHeader'
import DataCollectionListSummaryTableRow from './DataCollectionListSummaryTableRow'
import PropTypes from 'prop-types'
import React from 'react'
import { Table } from 'react-bootstrap'
import groupBy from 'lodash/groupBy'
import map from 'lodash/map'
import orderBy from 'lodash/orderBy'

/** React component which renders a datacollection list */
class DataCollectionListPanel extends React.Component {
  constructor(props) {
    super(props)

    this.getDataCollectionsGroupedByDataCollectionId = this.getDataCollectionsGroupedByDataCollectionId.bind(this)
  }

  render() {
    if (this.props.view === VIEW_DATASET_SUMMARY) {
      return (
        <Table hover responsive condensed className="table border-header runListFont">
          <DataCollectionListSummaryTableHeader />
          <tbody>
            {map(this.getDataCollectionsGroupedByDataCollectionId(), (dataCollectionGroup, index) =>
              dataCollectionGroup.map((dataCollection, index2) => (
                // render the run with a prop indicating the rowSpan for the first inex and 0 for the others.
                <DataCollectionListSummaryTableRow
                  key={String(index) + String(index2)}
                  dataCollection={dataCollection}
                  experimentId={this.props.experimentId}
                  proposal={this.props.proposal}
                  sessionId={this.props.sessionId}
                  user={this.props.user}
                  rowStyle={{
                    backgroundColor: index % 2 === 0 ? '#FFFFFF' : '#F9F9F9',
                    borderBottom: index2 === 2 ? '2px solid #3892d3' : null,
                  }}
                />
              ))
            )}
          </tbody>
        </Table>
      )
    } else if (this.props.view === VIEW_DATASET_MEASUREMENT) {
      return (
        <Table bordered striped hover responsive className="runListFont">
          <DataCollectionListMeasurementTableHeader />
          <tbody>
            {map(this.getDataCollectionsGroupedByDataCollectionId(), dataCollectionGroup =>
              dataCollectionGroup.map((dataCollection, index) => (
                // render the run with a prop indicating the rowSpan for the first inex and 0 for the others.
                <DataCollectionListMeasurementTableRow key={index} dataset={dataCollection} />
              ))
            )}
          </tbody>
        </Table>
      )
    }

    return null
  }

  /** Get grouped dataset by datacollectionId. This helps finding the number of runs per dataset as required for the rendering. */
  getDataCollectionsGroupedByDataCollectionId() {
    // Groups datasets by datacollectionId. Result is an object : { "datacollectionId1":{ [dataset1, dataset2 }, "datacollectionId2":{ [dataset3] } }
    const datasetsGroupedByDataCollectionId = groupBy(
      this.props.dataCollections,
      dataCollection => dataCollection.dataCollectionId
    )
    const finalArray = []
    for (var dataCollectionId in datasetsGroupedByDataCollectionId) {
      // Sort runs based on dataCollection order
      datasetsGroupedByDataCollectionId[dataCollectionId] = orderBy(
        datasetsGroupedByDataCollectionId[dataCollectionId],
        ['MeasurementToDataCollection_dataCollectionOrder'],
        ['desc']
      )

      // add the rowSpan property to each run
      datasetsGroupedByDataCollectionId[dataCollectionId] = map(
        datasetsGroupedByDataCollectionId[dataCollectionId],
        (value, index) => {
          if (index === 0) {
            value.rowSpan = datasetsGroupedByDataCollectionId[dataCollectionId].length
            // } else {
            //     value.rowSpan = 1;
          }
          return value
        }
      )
      finalArray.push(datasetsGroupedByDataCollectionId[dataCollectionId])
    }

    // reverse the result because groupBy() sorts dataCollection by their id
    return finalArray.reverse()
  }
}

export default DataCollectionListPanel

DataCollectionListPanel.propTypes = {
  /** Datacollections */
  dataCollections: PropTypes.array,
  /** experiment identifier */
  experimentId: PropTypes.number,
  /** ESRF session identifier */
  sessionId: PropTypes.string,
  /** dataset list view */
  view: PropTypes.string,
}
